import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
@Component({
  selector: 'app-eca-row-menu',
  templateUrl: './eca-row-menu.component.html',
  styleUrls: ['./eca-row-menu.component.scss']
})
export class EcaRowMenuComponent implements OnInit {

  @Input() viewBtnSize: any = "";
  @Input() viewBtnVisible: boolean = true;
  @Input() removeLabelOnMobile: boolean = false;
  @Input() viewBtnText: string = "View";
  @Input() menuVisible: boolean = true;

  @Input() rowMenuItems: MenuItem[];
  @Input() contextItem: any;
  @Input() menuLabel: string = '';
  @Input() isDisabled: boolean;
  @Input() rowMenuVisible: boolean = true;

  @Output() viewBtnClicked: EventEmitter<any> = new EventEmitter<any>();
  menuItems: MenuItem[] = [];

  constructor() { }

  ngOnInit(): void {
    //check if there are any items in the menu. If there are not then don't show the sub menu
    if (this.rowMenuItems === undefined || this.rowMenuItems.length == 0) {
      this.rowMenuVisible = false;
    }
    else {
      this.rowMenuItems?.forEach((item, index) => {
        let menuItem: MenuItem;
        //set up base properties
        menuItem = {
          label: item.label,
          icon: item.icon,
          styleClass: item.styleClass,
          visible: item.visible,
          disabled: item.disabled
        };
        //check for entity logic in terms of whether the menu item should be displayed
        if (item.state?.contextLogic) {
          menuItem.visible = this.contextItem[item.state?.contextLogic];
        };
        //update commands that are specific to entity/context
        menuItem.command = () => item.command?.(this.contextItem);
        this.menuItems.push(menuItem);
      });
    }
  }

  viewClicked() {
    this.viewBtnClicked.emit();
  }
}
